export default "__VITE_ASSET__0L0TIIQo__"